import type { Palette } from "building-types/materials/palette";
import type { PaletteMaterialSlot } from "building-types/materials/paletteMaterialSlotTypes";
import type { RoomType } from "building-types/rooms/roomTypesEnum";
import { pathStringFromMaterialSrcWithUserDefinedName } from "common/materials/pathStringFromMaterialSrc";
import { materialSrcFromPalette } from "doc/materialLookup";

export function materialKeyMeasureName(palette: Palette, paletteKey: PaletteMaterialSlot, roomType?: RoomType): string {
  const materialChoice = materialSrcFromPalette(palette, paletteKey, roomType, false);

  if (materialChoice !== undefined) {
    return pathStringFromMaterialSrcWithUserDefinedName(materialChoice);
  }

  return paletteKey;
}
